<section
  class="relative py-[2.5rem] w-screen left-[50%] right-[50%] -mx-[50vw]"
>
  <div
    class="absolute inset-0 z-0 pointer-events-none w-100vh h-full;"
    [class]="bgClass()"
  ></div>

  <div class="relative z-10 px-6">
    <div class="max-w-[78rem] mx-auto">
      <ng-content />
    </div>
  </div>
</section>
